// 语言key值
const attributeName = 'lang' 

// 获取语言。先从url上获取lang属性值，没有则取浏览器语言
function getLang() {
  let lang = getLangFromHash()
  if (lang) {
    return lang
  } else if (navigator.language) {
    lang = navigator.language.split('-')[0]
  }
  return lang
}

// 从url上获取翻译值
function getLangFromHash() {
  let lang = ''
  if (location.hash) {
    const index = location.hash.indexOf('?')
    const str =  location.hash.substring(index + 1)
    const attrs = str.split('&')
    const parmas = attrs.filter(item => {
      if (item.split('=')[0] === attributeName) {
        return item
      }
    })

    // 获取lang的值
    if (parmas.length > 0) {
      parmas.map((x, i) => {
        const item = x.split('=')
        lang = item[1] ? item[1] : langConfig.defaultLang
      })
    }
  } 
  return lang
}

// 获取语言
let localeEnv = getLang()
// 获取的语言值不在配置语言范围内时，设置为默认语言
if (langConfig.langRange.indexOf(localeEnv) < 0) {
  localeEnv = langConfig.defaultLang
}

// 设置图片语言值，支持en|zh。如果当前语言不是中英文，则默认获取英文图片
let imgLocale = (localeEnv === 'zh' || localeEnv === 'en') ? localeEnv : 'en'

export { 
  localeEnv,
  imgLocale
}



// WEBPACK FOOTER //
// ./src/lang/utils.js